import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon---icon-bg-circle-solid",
  "use": "icon---icon-bg-circle-solid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon---icon-bg-circle-solid\">\n    <title>icons/--icon-bg-circle-solid</title>\n    <g id=\"icon---icon-bg-circle-solid_icons/--icon-bg-circle-solid\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon---icon-bg-circle-solid_Oval\" fill=\"#94A1AF\" cx=\"12\" cy=\"12\" r=\"12\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol